import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';
import { ReleaseStepApprovalsData, ReleaseStepType } from '@/types';
import Flex from 'antd/lib/flex';
import {
    RegressionOrApprovalItemsProgressBar,
    RegressionOrApprovalItemsSummaryTable,
} from './RegressionTestingStepRunSummaryPanel';

export const ApprovalsStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({
    stepRun,
    orgId,
    appId,
    releaseVersion,
    shouldDisplayCompactVersion,
}) => {
    const stepData: ReleaseStepApprovalsData = {
        ...stepRun.data.summaryData,
        ...stepRun.data.complementaryData,
    };

    return (
        <Flex vertical gap={20} style={{ padding: '2px 2px 0px 2px' }}>
            <RegressionOrApprovalItemsProgressBar
                items={stepData.approvalItems}
                stepArchetype={ReleaseStepType.Approvals}
                compact={shouldDisplayCompactVersion}
            />
            <RegressionOrApprovalItemsSummaryTable
                items={stepData.approvalItems}
                orgId={orgId}
                appId={appId}
                releaseVersion={releaseVersion}
                stepRunId={stepRun.id}
                stepArchetype={ReleaseStepType.Approvals}
            />
        </Flex>
    );
};
